<div class="header-bar">
  <div class="header-left"></div>
  <div class="header-center">
    {{ newAccount ? "Create New Account" : "Account" }}
  </div>
  <div *ngIf="newAccount" class="header-right">
    <button mat-button color="fiord" (click)="cancel()">Cancel</button>
    <button
      mat-button
      color="lightGreen"
      (click)="saveNewAccount()"
      [disabled]="saveDisabled"
    >
      Save New Account
    </button>
  </div>
  <div *ngIf="!newAccount" class="header-right">
    <button
      *ngIf="currentAccount.accountID === account!.id"
      mat-button
      color="warn"
      (click)="deleteAccount()"
    >
      Delete Account
    </button>
    <button
      mat-button
      color="lightGreen"
      (click)="saveAccountUpdates()"
      [disabled]="saveDisabled"
    >
      Save Account Updates
    </button>
    <button mat-button color="lightGreen" (click)="editCatalog()">
      Edit Catalog
    </button>
  </div>
</div>

<div class="account">
  <div class="containers left-containers">
    <div class="container account-details-container">
      <div class="container-header no-bottom-border">
        <div class="text">Account Details</div>
      </div>
      <div class="container-content">
        <div class="container-row">
          <lhpe-input
            class="input"
            controlName="companyName"
            placeholder="Company name"
            [formGroup]="accountForm!"
            [required]="true"
          >
          </lhpe-input>
        </div>
        <div class="container-row">
          <lhpe-input
            class="input"
            controlName="companyAddress"
            placeholder="Company address"
            [formGroup]="accountForm!"
            [required]="true"
          >
          </lhpe-input>
        </div>
        <div class="container-row">
          <lhpe-input
            controlName="suiteUnitEtc"
            placeholder="Suite, Unit, etc."
            [formGroup]="accountForm!"
          >
          </lhpe-input>
        </div>

        <div class="container-row">
          <lhpe-input
            class="half-input"
            controlName="city"
            placeholder="City"
            [formGroup]="accountForm!"
            [required]="true"
          >
          </lhpe-input>
          <lhpe-select
            class="quarter-input"
            controlName="state"
            placeholder="State"
            [formGroup]="accountForm!"
            [required]="true"
            [options]="statesOptions"
          >
          </lhpe-select>
          <lhpe-input
            class="quarter-input"
            controlName="zip"
            placeholder="Zip"
            [formGroup]="accountForm!"
            [required]="true"
          >
          </lhpe-input>
        </div>

        <div class="container-row">
          <lhpe-input
            class="half-input"
            controlName="firstName"
            placeholder="Primary contact first name"
            [formGroup]="accountForm!"
            [required]="true"
          >
          </lhpe-input>
          <lhpe-input
            class="half-input"
            controlName="lastName"
            placeholder="Last name"
            [formGroup]="accountForm!"
            [required]="true"
          >
          </lhpe-input>
        </div>
        <div class="container-row">
          <lhpe-input
            class="half-input"
            controlName="email"
            placeholder="Primary contact email"
            [formGroup]="accountForm!"
            [required]="true"
          >
          </lhpe-input>
          <lhpe-input
            class="half-input"
            controlName="phone"
            placeholder="Primary contact phone"
            [formGroup]="accountForm!"
            [required]="true"
            mask="(000) 000-0000"
          >
          </lhpe-input>
        </div>
        <div class="container-row">
          <lhpe-select
            controlName="businessCategory"
            placeholder="Business Category"
            [formGroup]="accountForm!"
            [required]="true"
            [options]="businessCategoryOptions"
          >
          </lhpe-select>
        </div>
      </div>
    </div>

    <div class="container features-container">
      <div class="container-header no-bottom-border">
        <div class="text">Features</div>
      </div>
      <div class="container-content">
        <div class="checkbox-group">
          <div class="checkbox" *ngFor="let f of features">
            <mat-checkbox
              [(ngModel)]="f.selected"
              color="lightGreen"
              labelPosition="before"
              >{{ f.name }}</mat-checkbox>
              
          </div>
        </div>
      </div>
    </div>

    <div
      *ngIf="hasCategoriesList"
      class="container account-categories-container"
    >
      <div class="container-header no-bottom-border">
        <div class="text">Account Categories</div>
        <div *ngIf="hasCategoriesWrite" class="options">
          <button mat-icon-button [matMenuTriggerFor]="categoryMeny">
            <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
          </button>
          <mat-menu
            class="mat-menu-elaphant vertical-menu"
            #categoryMeny="matMenu"
          >
            <button
              *ngIf="hasCategoriesWrite"
              class="icon-btn-w-text"
              mat-menu-item
              (click)="addNewCategory()"
            >
              <svg-icon src="assets/svg/plus-circle-white.svg"></svg-icon>
              <span>Add new Category</span>
            </button>
          </mat-menu>
        </div>
      </div>
      <div class="container-content">
        <table
          #categoriesTable
          mat-table
          [dataSource]="categoriesDataSource"
          matSort
        >
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
            <td mat-cell *matCellDef="let row">
              {{ row.name ? row.name : "-" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="icon">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Icon</th>
            <td mat-cell *matCellDef="let row">
              {{ row.icon ? row.icon : "-" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="color">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Color</th>
            <td mat-cell *matCellDef="let row">
              {{ row.color ? row.color : "-" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="preview">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
              <div
                [ngStyle]="{
                  'background-color': row.color,
                  display: 'flex',
                  'justify-content': 'center',
                  'border-radius': '5px'
                }"
              >
                <span
                  style="
                    min-width: 30px;
                    display: 'flex';
                    justify-content: 'center';
                  "
                  ><fa-icon style="color: white" [icon]="row.iconArr"></fa-icon
                ></span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="options">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row" class="options-cell">
              <button
                *ngIf="hasCategoriesWrite"
                mat-button
                class="icon-btn"
                (click)="editCategory(row)"
              >
                <svg-icon
                  src="assets/svg/pencil.svg"
                  svgClass="lightBlue"
                ></svg-icon>
              </button>
              <div *ngIf="!hasCategoriesWrite" class="empty-btn-space"></div>

              <button
                *ngIf="hasCategoriesDelete"
                class="icon-btn"
                mat-button
                (click)="deleteCategory(row)"
              >
                <svg-icon
                  src="assets/svg/trashcan.svg"
                  [svgStyle]="{
                    'width.px': '15.25',
                    'height.px': '16.204'
                  }"
                  svgClass="lightBlue"
                ></svg-icon>
              </button>
              <div *ngIf="!hasCategoriesDelete" class="empty-btn-space"></div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedCategoryColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedCategoryColumns"
          ></tr>
        </table>
        <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="perPage" (page)="onPageChange($event)"></mat-paginator>
      </div>
    </div>

    <!-- <div class="container service-level-container">
      <div class="container-header no-bottom-border">
        <div class="text">Service Level</div>
      </div>
      <div class="container-content">
        <div class="container-row">
          <mat-radio-group
            class="mat-lightGreen"
            [value]="accountForm.controls.serviceLevel.value"
            aria-label="Select a service level"
          >
            <mat-radio-button
              class="mat-lightGreen"
              value="engage"
              (click)="changeServiceLevelValue('engage')"
              >Engage</mat-radio-button
            >
            <mat-radio-button
              class="mat-lightGreen"
              value="observe"
              (click)="changeServiceLevelValue('observe')"
              >Observe</mat-radio-button
            >
            <mat-radio-button
              class="mat-lightGreen"
              value="enterprise"
              (click)="changeServiceLevelValue('enterprise')"
            >
              Enterprise</mat-radio-button
            >
          </mat-radio-group>
        </div>
      </div>
    </div> -->
  </div>
  <div class="containers right-containers" *ngIf="!newAccount">
    <div
      *ngIf="unassignedUsers?.length && showUnassignedPersonnel"
      class="container unassigned-personnel-container"
    >
      <div class="container-header no-bottom-border">
        <div class="text">Unassigned Personnel</div>
      </div>
      <div class="container-content">
        <div class="search-box input-box">
          <svg-icon src="assets/svg/magnifier.svg"></svg-icon>

          <mat-form-field>
            <input
              matInput
              (keyup)="applyFilter()"
              matInput
              type="text"
              [(ngModel)]="searchValue"
            />
          </mat-form-field>
        </div>

        <mat-accordion
          *ngIf="hasSearchValue && hasResults"
          class="user-accordian"
        >
          <mat-expansion-panel
            *ngFor="let user of filteredUsers"
            [(expanded)]="user.expanded"
            (opened)="initAccountUserForm()"
            hideToggle
          >
            <mat-expansion-panel-header
              [ngClass]="{ 'prevent-open': openedUser }"
            >
              <mat-panel-title>
                {{
                  user.firstName && user.lastName
                    ? user.firstName + " " + user.lastName
                    : user.email
                }}</mat-panel-title
              >
              <button [disabled]="!!openedUser" mat-button class="add-btn">
                <svg-icon src="assets/svg/plus-circle.svg"></svg-icon>
              </button>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <form
                *ngIf="openedUser"
                class="account-user"
                [formGroup]="accountUserForm"
              >
                <div class="role">
                  <lhpe-select
                    controlName="role"
                    placeholder="Role"
                    [formGroup]="accountUserForm"
                    [required]="true"
                    [options]="roles"
                    optionValue="id"
                  >
                  </lhpe-select>
                </div>
                <div class="groups">
                  <div class="input-box">
                    <mat-form-field class="select-form">
                      <mat-label *ngIf="groups?.length">Groups</mat-label>
                      <mat-label *ngIf="!groups?.length"
                        >No Groups To Select</mat-label
                      >
                      <mat-select formControlName="groups" multiple>
                        <mat-option
                          class="mat-lightGreen"
                          *ngFor="let group of groups"
                          [value]="group.id"
                          >{{ group.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div>
                    <lhpe-option-snack-group class="groups">
                      <lhpe-option-snack
                        *ngFor="let selectedGroup of selectedGroupsObjArr"
                        [option]="selectedGroup"
                        name="{{ selectedGroup.name }}"
                        (optionRemoved)="removeGroup($event)"
                      >
                      </lhpe-option-snack>
                    </lhpe-option-snack-group>
                  </div>
                </div>
                <div class="facilities">
                  <div
                    *ngIf="facilities.length > 1"
                    class="facilities-restriction-toggle"
                  >
                    <div class="label">Restrict Facilities</div>

                    <mat-slide-toggle
                      color="lightGreen"
                      formControlName="showFacilitiesRestriction"
                      [checked]="
                        accountUserForm.controls.showFacilitiesRestriction.value
                      "
                      (click)="onShowRestrictionsClicked()"
                    >
                      {{
                        accountUserForm.controls.showFacilitiesRestriction.value
                          ? "Enabled"
                          : "Disabled"
                      }}
                    </mat-slide-toggle>
                  </div>
                  <div
                    *ngIf="
                      accountUserForm.controls.showFacilitiesRestriction.value
                    "
                    class="facilities-list"
                  >
                    <div *ngFor="let facility of facilities">
                      <mat-checkbox
                        [checked]="!!selectedFacilities?.includes(facility.id)"
                        color="lightGreen"
                        (click)="onFacilityToggled(facility)"
                        >{{ facility.name }}</mat-checkbox
                      >
                    </div>
                  </div>
                </div>
              </form>
              <div class="buttons">
                <button
                  class="btn"
                  color="fiord"
                  mat-button
                  (click)="closeAccountUser()"
                >
                  Close
                </button>
                <button
                  class="btn"
                  color="lightGreen"
                  mat-button
                  [disabled]="accountUserForm.invalid"
                  (click)="saveAccountUser(openedUser!)"
                >
                  Save
                </button>
              </div>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>

        <div *ngIf="!hasSearchValue || !hasResults" class="info-msg">
          <div *ngIf="!hasSearchValue">Please search for a user</div>
          <div *ngIf="hasSearchValue && !hasResults">No results found</div>
        </div>
      </div>
    </div>

    <div
      *ngIf="account?.users?.length"
      class="container team-members-container"
    >
      <div class="container-header no-bottom-border">
        <div class="text">Team Members for {{ account?.name }}</div>
      </div>
      <div class="container-content">
        <lhpe-option-snack-group style="max-width: 100%">
          <lhpe-option-snack
            *ngFor="let user of account?.users"
            [option]="user"
            name="{{
              user.first_name && user.first_name
                ? user.first_name + ' ' + user.last_name
                : user.email
            }}"
            (optionRemoved)="onUserRemoved($event)"
            [disabled]="disableTeamMemberRemove"
            style="max-width: 100%"
          >
          </lhpe-option-snack>
        </lhpe-option-snack-group>
      </div>
    </div>

    <div class="container billing-container" *ngIf="!newAccount">
      <div class="container-header no-bottom-border">
        <div class="text">Stripe Customers</div>
      </div>
      <div class="container-content">
          <p>
            Provides Customer Portal links in Preferences: Manage Billing
          </p>
          <div class="stripe-customer" *ngFor="let customer of account?.stripeCustomers">
            <lhpe-input
              class="half-input"
              controlName="{{customer.id+'_stripe_name'}}"
              placeholder="Stripe Customer Name"
              [formGroup]="accountForm!"
              [required]="true"
            >
            </lhpe-input>
            <lhpe-input
              class="half-input"
              controlName="{{customer.id+'_stripe_id'}}"
              placeholder="Stripe Customer ID"
              [formGroup]="accountForm!"
              [required]="true"
            >
            </lhpe-input>
            <button mat-button class="btn" color="warn" (click)="deleteStripeCustomer(customer)">Delete</button>
          </div>
          <div class="stripe-customer">
            <lhpe-input
              class="half-input"
              controlName="new_stripe_name"
              placeholder="Stripe Customer Name"
              [formGroup]="accountForm!"
              [required]="true"
            >
            </lhpe-input>
            <lhpe-input
              class="half-input"
              controlName="new_stripe_id"
              placeholder="Stripe Customer ID"
              [formGroup]="accountForm!"
              [required]="true"
            >
            </lhpe-input>
            <button mat-button class="btn" color="lightGreen" (click)="saveNewStripeCustomer()" [disabled]="newStripeCustomerDisabled">Add</button>
          </div>
      </div>
    </div>

  </div>
</div>
